import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { InactionCostSection } from './components/InactionCostSection';
import { AuthorNote } from './components/AuthorNote';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <InactionCostSection data-id="element-10" />
      <AuthorNote data-id="element-11" />
      <FAQSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}